export const selectParameterAnalyticsDetailedState = (state) =>
  state.parameterAnalyticsDetailed || {};

export const selectTableData = (state) =>
  selectParameterAnalyticsDetailedState(state).detailedData || [];

export const selectLoading = (state) =>
  selectParameterAnalyticsDetailedState(state).loading || false;

export const selectError = (state) =>
  selectParameterAnalyticsDetailedState(state).error;

export const selectPagination = (state) =>
  selectParameterAnalyticsDetailedState(state).pagination || { 
    currentPage: 1, 
    pageSize: 10, 
    totalCount: 0,
    totalPages: 1,
    hasNextPage: false,
    hasPrevPage: false
  };

export const selectFilters = (state) =>
  selectParameterAnalyticsDetailedState(state).appliedFilters || {
    testType: "All",
    parameterType: "All",
    commodity: "All",
    sortBy: "compliance",
    parameter: "All",
    sortOrder: "desc"
  };